import * as R from 'remeda'

import { exists } from '~/utils'

import { useAtomValueContext } from '../providers/AtomsProvider'
import { type RowData } from '../utils'

export const useSortFunc = (
  name: 'individualSortValue' | 'matrixSortValue' | 'sequentialSortValue',
) => {
  const dataDisplayType = useAtomValueContext('dataDisplayType')

  const sortValue = useAtomValueContext(name)

  type ColumnKeyOf<T> = T extends {
    columnKey: infer U
  }
    ? U
    : never
  type ColumnKey = ColumnKeyOf<typeof sortValue>

  return <T extends RowData<ColumnKey>>(rowsData: T[]) =>
    R.sortBy(rowsData, (rowData) => {
      if (!exists(sortValue)) {
        return 0
      }

      const value =
        dataDisplayType === 'percentage'
          ? rowData.ratios[sortValue.columnKey]
          : rowData.counts[sortValue.columnKey]

      return value * (sortValue.ascending ? 1 : -1)
    })
}
